import React from 'react'
import Sidebar from './Navigation/Sidebar'
import { useLocation, useNavigate } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons'
import moment from 'moment-timezone'

const Layout = ({
  children,
  activeNav,
  isBackButtonShown,
  isDetailShown,
  detail,
  isPreviewShown,
  previewComponent,
}) => {
  const navigate = useNavigate()
  const location = useLocation()

  return (
    <div className="flex relative min-h-screen bg-canvas bg-gradient-to-b from-[#F1F1F4] to-[#E2E3E8]">
      <div className="p-3 sticky top-0 h-screen">
        <Sidebar />
      </div>
      {location.pathname.includes('/konten') &&
        (isBackButtonShown || isDetailShown) && (
          <div className="w-[260px] flex-none sticky top-0 h-[fit-content] p-3">
            {isBackButtonShown && (
              <button
                type="button"
                className="flex items-center gap-2 mb-3 text-sm font-medium text-muted hover:text-ink transition-colors"
                onClick={() => navigate(-1)}
              >
                <FontAwesomeIcon icon={faAngleLeft} className="text-xs" />
                Kembali
              </button>
            )}

            {isDetailShown && (
              <div className="rounded-card border border-line bg-white shadow-card px-4 py-4">
                <p className="font-bold text-base text-ink mb-3">{activeNav}</p>
                <dl className="flex flex-col gap-3">
                  <div>
                    <dt className="text-[12px] text-muted">Dibuat</dt>
                    <dd className="text-sm text-ink">
                      {moment(detail?.attributes.createdAt)
                        .tz('Asia/Jakarta')
                        .format('dddd, D MMM YYYY [di] HH:mm')}
                    </dd>
                  </div>
                  <div>
                    <dt className="text-[12px] text-muted">
                      Terakhir Diperbaharui
                    </dt>
                    <dd className="text-sm text-ink">
                      {moment(detail?.attributes.updatedAt)
                        .tz('Asia/Jakarta')
                        .format('dddd, D MMM YYYY [di] HH:mm')}
                    </dd>
                  </div>
                  <div>
                    <dt className="text-[12px] text-muted">ID</dt>
                    <dd className="text-sm text-ink">{detail?.id}</dd>
                  </div>
                </dl>
              </div>
            )}
          </div>
        )}

      <div className="flex-1">{children}</div>

      {location.pathname.includes('/konten') && isPreviewShown && (
        <div className="w-[340px] flex-none sticky top-0 h-[fit-content] p-3 pl-0">
          <div className="rounded-card border border-line bg-white shadow-card px-4 py-4">
            {previewComponent}
          </div>
        </div>
      )}
    </div>
  )
}

export default Layout
